import { AxiosResponse } from 'axios';
import { DataRackListGetRequest, DataRackListGetResponse } from 'types/entity-ddms';
import { httpByDdms } from './settings';

export const fetchDataRack = (dataRackListGetRequest: DataRackListGetRequest): Promise<DataRackListGetResponse> => httpByDdms.post('/data-racks/search', dataRackListGetRequest)
  .then((value: AxiosResponse<DataRackListGetResponse>) => value.data || []);
